/**
 * LlamaaSushi Shopify Theme
 * Main JavaScript Entry Point
 */

import Alpine from 'alpinejs';

// Import other dependencies
import { gsap } from 'gsap';
import { createIcons, Menu, X, ChevronDown, ChevronLeft, ChevronRight, ShoppingBag, User, Truck, Phone, Clock, House, Book, Fish, Layers, Bike } from 'lucide';

// Make GSAP available globally
window.gsap = gsap;

// Import stores
import cartStore from './stores/cart';
import businessHoursStore from './stores/businessHours';
import variantModalStore from './stores/variantModal';

// Import components (side-effect only - registers Alpine.data)
import './components/cart';
import './components/product';
import './components/product-card';
import './components/navigation';
import './components/business-hours';
import './components/collections-swiper';
import './components/newsletter';

// Make Alpine available globally
window.Alpine = Alpine;

// Register Alpine.js stores
Alpine.store('cart', cartStore());
Alpine.store('business', businessHoursStore());
Alpine.store('variantModal', variantModalStore());

// Helper function to initialize Lucide icons
function initializeLucideIcons() {
  createIcons({
    icons: {
      Menu,
      X,
      ChevronDown,
      ChevronLeft,
      ChevronRight,
      ShoppingBag,
      User,
      Truck,
      Phone,
      Clock,
      House,
      Book,
      Fish,
      Layers,
      Bike,
    },
  });
}

// Initialize Alpine when DOM is ready
document.addEventListener('DOMContentLoaded', async () => {
  // Initialize Lucide icons
  initializeLucideIcons();

  // Fetch cart data BEFORE starting Alpine
  await Alpine.store('cart').fetchCart();

  // Initialize business hours
  Alpine.store('business').init();

  // Start Alpine
  Alpine.start();
});

// Shopify section reloading support
document.addEventListener('shopify:section:load', () => {
  Alpine.store('cart').updateCount();
  initializeLucideIcons();
});

export { Alpine };
